import {studyDefinitionModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import EnumValueSetDto = MdbsCore.EnumValueSetDto;
import EnumValueDefinitionDto = MdbsCore.EnumValueDefinitionDto;

/**
 * Resolves an enum value set by its identifier.
 *
 * Repeated study-definition imports can leave several sets with the same identifier in the
 * database — older ones flagged as deleted. A plain `.find()` returns whichever comes first,
 * so it may hand back a stale set with no usable values. Prefer the set that is neither
 * deleted nor obsolete, fall back to any non-deleted one, and only then give up.
 */
export const findEnumValueSet = function (identifier?: string): EnumValueSetDto | undefined {
    if (!identifier)
        return undefined;

    const sets = studyDefinitionModule.studyDefinition.enumValueSets
        ?.filter(e => e.identifier == identifier && !e.isDeleted) ?? [];

    return sets.find(e => !e.isObsolete) ?? sets[0];
}

/** Selectable values of a set: obsolete entries are kept in the definition but must not be offered. */
export const activeEnumValues = function (set?: EnumValueSetDto): EnumValueDefinitionDto[] {
    return (set?.values ?? []).filter(v => !v.isObsolete);
}

/** Resolves a single value of a set by its code, ignoring stale sets. */
export const findEnumValue = function (identifier?: string, code?: string): EnumValueDefinitionDto | undefined {
    if (!code)
        return undefined;
    return findEnumValueSet(identifier)?.values?.find(v => v.code == code);
}
